import Modal from "@/components/common/Modal";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { DepositsItem } from "@/modules/user/types/wallet";
import { useTranslation } from "react-i18next";

type Props = {
  onClose: () => void;
};

const NewRateDescription = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { deposits } = useUserStore();

  const aggregateDepositsByRate = (deposits: DepositsItem[]) => {
    const flat = deposits.map((d: DepositsItem) => ({
      ...d.deposit,
      createdAt: new Date(d.deposit.createdAt),
      rate: d.deposit.tokenUsdPrice,
    }));

    // rate -> totalTokenAmount
    const byRate = new Map<number, number>();

    for (const d of flat) {
      const prev = byRate.get(d.rate) ?? 0;
      byRate.set(d.rate, prev + d.tokenAmount);
    }

    return byRate;
  };

  const resDeposits = aggregateDepositsByRate(deposits || []);

  return (
    <Modal title={t("new-rate.modal.title")} onClose={onClose}>
      <div className="w-full flex flex-col items-center px-4 pb-5 gap-3">
        <p className="w-full text-[1.25rem] leading-[1.5625rem] font-semibold text-left w-full">
          {t("new-rate.modal.title_2")}
        </p>

        <p className="text-[1.0625rem] leading-[1.375rem] text-left w-full">
          {t("new-rate.modal.each")}
        </p>
        <img
          src="/images/btn-rate.png"
          alt=""
          className="shrink-0 w-full h-[12.5rem] object-contain rounded-xl"
        />

        <p className="w-full text-[1.0625rem] leading-[1.375rem] text-left w-full text-hint whitespace-pre-line">
          {Array.from(resDeposits.entries())
            .sort(([rateA], [rateB]) => rateA - rateB)
            .map(([rate, totalAmount]) =>
              t("new-rate.modal.you_have", {
                amount: formatNumber(totalAmount, {
                  precision: 2,
                }),
                rate: rate,
              })
            )
            .join("\n")}
        </p>
      </div>
    </Modal>
  );
};

export default NewRateDescription;
